import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { media, screenSizes, Container, StyledContainer, containerCss } from '../../helpers/styleConstants';
import { Button, Typography, Card, Icon, CardAction, Theme } from 'rmwc';
import { LoadingBar } from '../../components/util/LoadingBar';
import { ScoreTabbed } from '../../components/Onboarding/ScoreVariants';
import { CTAOptDense } from '../../components/Onboarding/CtaVariants';
import { Text } from '../../components/Text';
import { PlanScorePanel } from '../PlanScorePanel';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';
import { isTest } from '../../helpers/environment';

import { nextIntroStep, updateDashboardData } from '../../actions/dashboardActions';
import { fetchAccountsModule } from '../../actions/accountsActions';
import { fetchIncomes } from '../../actions/incomesActions';
import { fetchJobsModule } from '../../actions/jobsActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchSpendingPlan, fetchWealthManagement } from '../../actions/wealthManagementActions';
import { fetchSavingsModule } from '../../actions/savingsActions';
import { nilSingleScore } from '../../actions/toolsActions';
import { runFullSimulation } from '../../actions/simulationActions';
import { trackEvent } from '../../actions/trackEventActions';
import { updateFrame } from '../../actions/uiActions';

import { currencyFormatter, roundTo } from '../../components/Money';
import { wlPath, wlVar } from '../../helpers/whitelabel';
import { camelToKebabCase, kebabToCamelCase } from '../../helpers/stringHelper';
import { newWindow } from '../../helpers/newWindow';
import { logEvent } from '../../helpers/analytics';

import { COLLECT_CONTACT_ON_ACTION_ITEMS } from '../../helpers/constants';

import { MTHeader, MTSkinny } from '../Microtools/layout';

// for debugging purposes so we don't need to create lots of accounts to edit this page
let DEBUG_STEP = undefined;
if (false) {
  DEBUG_STEP = 2;
}

const SHOW_TOP_THREE = 3;
const TEASE_MORE_ITEMS = 4;
const FINISHED = 5;

const MAX_ITEMS_TO_SHOW = 6;

// TOOD: Replace with new RMWC
const ToggleCard = ({ children, elevated, onClick, noRipple }) => {
  if (elevated) {
    return (
      <Card style={{ backgroundColor: 'white', border: '1px solid white' }} className="mdc-elevation--z2 p-2 mt-1">
        {children}
      </Card>
    );
  } else {
    return (
      <Card
        style={{ boxShadow: 'none', border: '1px solid #dbdbdb' }}
        className={`${noRipple ? '' : 'fake-ripple-white'} p-2 mt-1`}
        onClick={onClick}
      >
        {children}
      </Card>
    );
  }
};

const StyledCAImage = styled.div`
  height: 50px;

  @media (max-width: 350px) {
    display: none;
  }
`;

const CAImage = ({ image }) => (
  <StyledCAImage className="m-2 mr-3">
    <img src={image} style={{ width: '50px' }} />
  </StyledCAImage>
);

const ActionItemCTAs = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.5rem;

  ${media.tabletPortraitUp`
    flex-diection: row-reverse;
  `};
`;

export const CarouselAction = ({
  open,
  onToggle,
  onClick,
  onRemove,
  image,
  title,
  subtitle,
  explanation,
  hideExplanation,
  background,
  gain,
}) =>
  open ? (
    <div>
      <ToggleCard elevated={true}>
        <div style={{ display: 'flex' }}>
          <CAImage image={image} />
          <div>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography tag="div" use="headline6" className="mb-2">
                  {title}
                </Typography>
                <div style={{ cursor: 'pointer' }}>
                  <Icon onClick={onToggle} className="fake-ripple-icon p-1" theme="text-secondary-on-background">
                    expand_less
                  </Icon>
                </div>
              </div>
            </div>
            <div>
              <Text use="body1">{subtitle}</Text>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography tag="div" use="body1">
                {gain ? (
                  <div>
                    <strong style={{ color: 'rgb(41, 149, 85)' }}>+{currencyFormatter(roundTo(gain, -3))}</strong>
                    {' potential value. '}
                    <a href={wlPath('/action-plan-value')} >See Calculation</a>
                  </div>
                ) : null}
              </Typography>
              <ActionItemCTAs>
                <Button theme="secondary-bg on-secondary" onClick={onClick}>
                  Learn How
                </Button>
                <Button theme="secondary" onClick={onRemove} className="mr-2">
                  No Thanks
                </Button>
              </ActionItemCTAs>
            </div>
          </div>
        </div>
      </ToggleCard>
      {hideExplanation || (
        <Typography
          style={{ position: 'relative', paddingLeft: '30px', marginTop: '0.25rem', marginBottom: '0.5rem' }}
          tag="div"
          use="body1"
          theme="text-secondary-on-background"
        >
          <div style={{ position: 'absolute', width: '30px', left: '0', top: '0', textAlign: 'right' }}>
            <Icon style={{ fontSize: '18px', padding: '1px 5px 0 0', color: '#F2C94C' }}>info</Icon>
          </div>
          {explanation}
        </Typography>
      )}
    </div>
  ) : (
    <div>
      <ToggleCard elevated={false} onClick={onToggle}>
        <div style={{ display: 'flex', cursor: 'pointer' }}>
          <CAImage image={image} />
          <div style={{ flexGrow: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography use="subtitle1" tag="div" className="pt-1">
                {title}
              </Typography>
              <div style={{ cursor: 'pointer' }}>
                <Icon onClick={onToggle} className="fake-ripple-icon p-1" theme="text-secondary-on-background">
                  add
                </Icon>
              </div>
            </div>
            <Typography tag="div" use="body1">
              {gain ? (
                <div>
                  <strong style={{ color: 'rgb(41, 149, 85)' }}>+{currencyFormatter(roundTo(gain, -3))}</strong>
                  {' potential value'}
                </div>
              ) : null}
            </Typography>
          </div>
        </div>
      </ToggleCard>
    </div>
  );

export const CustomCTA = ({
  heading = 'Let us help you create a personalized plan',
  children,
  onClick,
  trackEvent,
}) => (
  <Theme
    use={wlVar('white_header') ? '' : 'primary-bg'}
    tag="div"
    className="p-3 mt-2"
    style={{
      marginLeft: '-15px',
      marginRight: '-15px',
    }}
  >
    <div className="p-2" style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ marginRight: '1rem' }}>
          <img className="hrbr-avatar" style={{ width: '100px' }} src={wlVar('headshot_url')} />
        </div>
        <div style={{ flexGrow: 1 }}>
          <Typography tag="div" use="headline6" theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}>
            {heading}
          </Typography>
          <Typography tag="div" use="body1" theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}>
            Schedule a free 30-minute consultation
          </Typography>
        </div>
      </div>
      <div>{children}</div>
    </div>

    <div className="p-2" style={{ display: 'flex', justifyContent: 'flex-start' }}>
      <Button
        onClick={() => {
          trackEvent('CLICKED_SCHEDULE_CALL_LINK');
          newWindow(wlVar('link_href_consult'), 'PlanIntroCTA');
        }}
        theme="secondary-bg on-secondary"
      >
        {wlVar('link_label_consult')}
      </Button>
      <Button
        className="mr-2"
        onClick={() => newWindow(wlVar('link_href_services'), 'PlanIntroCTA')}
        target="_blank"
        theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
      >
        {wlVar('link_label_services')}
      </Button>
    </div>
  </Theme>
);

class UnconnectedPlanCTA extends Component {
  render() {
    return (
      <CustomCTA {...this.props}>
        <Typography
          tag="div"
          use="body1"
          className="pt-2"
          theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
        >
          This planning preview is a great place to get started. If you're interested in any of the ideas listed here,
          and want to know how our team can help, we'd love to talk.
        </Typography>
        <Typography
          tag="div"
          use="body1"
          className="pt-2 pb-2"
          theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
        >
          We'll review every unique aspect of your situation, and work with you to develop a strategy that meets all of
          your needs.
        </Typography>
      </CustomCTA>
    );
  }
}
export const PlanCTA = connect(null, { trackEvent })(UnconnectedPlanCTA);

export class PlanIntro extends Component {
  constructor(props) {
    super(props);

    let intro_step;
    if (props.dashboard.intro_step > 0 && props.dashboard.intro_step < SHOW_TOP_THREE) {
      intro_step = DEBUG_STEP || props.dashboard.intro_step;
    } else {
      intro_step = 1;
    }

    this.state = {
      open_step: intro_step,
    };
  }

  handleLeave = e => {
    if (
      e.clientY < 0 &&
      this.props.user.email_cohort === COLLECT_CONTACT_ON_ACTION_ITEMS &&
      /guest.*@harborplan.com/.test(this.props.user.email)
    ) {
      this.props.openRegistrationDialog(() => {}, () => {}, 'BEFORE_YOU_LEAVE');
    }
  };

  componentDidMount() {
    this.props.updateFrame('Potential Planning Ideas for You', 'meeting.png');
    document.addEventListener('mouseleave', this.handleLeave);
    if (!this.props.people.length) this.props.fetchPeople();
    if (!this.props.accounts) this.props.fetchAccountsModule();
    if (!this.props.annuities || !this.props.pensions || !this.props.trustFunds || !this.props.unclassifiedIncomes) {
      this.props.fetchIncomes();
    }
    if (!this.props.jobs) this.props.fetchJobsModule();
    if (!this.props.results) this.props.runFullSimulation();
    if (!this.props.savings) this.props.fetchSavingsModule();
    if (!this.props.spendingPlan) this.props.fetchSpendingPlan();
    if (!this.props.wealthManagement) this.props.fetchWealthManagement();
    this.props.nilSingleScore();

    this.props.trackEvent('SAW_ACTION_PLAN');
  }

  componentWillUnmount() {
    document.removeEventListener('mouseleave', this.handleLeave);
  }

  nextIntroStep = () => {
    if (this.props.dashboard.intro_step === 0) {
      this.props.nextIntroStep(2);
      this.changeOpen(2);
    } else {
      this.props.nextIntroStep(this.props.dashboard.intro_step + 1);
      this.changeOpen(this.props.dashboard.intro_step + 1);

      const numberOfItems = this.calculateNumberOfItemsToShow(this.props.dashboard.intro_step + 1);
      if (numberOfItems === MAX_ITEMS_TO_SHOW) {
        logEvent('MaxActionItemDisplayed');
        this.props.trackEvent('REVEALED_MAX_ACTION_ITEMS');
      } else if (numberOfItems === SHOW_TOP_THREE) {
        this.props.trackEvent('REVEALED_THREE_ACTION_ITEMS');
      }
    }
  };

  removeStep = key => {
    const { removed_steps } = this.props.dashboard;
    if (removed_steps) {
      this.props.updateDashboardData({ removed_steps: removed_steps.concat(key) });
    } else {
      this.props.updateDashboardData({ removed_steps: [key] });
    }
    logEvent('NotInterestedActionItem', {
      action_item: key,
    });
  };

  calculateNumberOfItemsToShow = step => {
    let numberOfItemsToShow = 0;
    if ((DEBUG_STEP || step) <= SHOW_TOP_THREE) {
      numberOfItemsToShow = DEBUG_STEP || step || 1;
    } else if ((DEBUG_STEP || step) === 4) {
      numberOfItemsToShow = SHOW_TOP_THREE;
    } else {
      numberOfItemsToShow = MAX_ITEMS_TO_SHOW;
    }
    return numberOfItemsToShow;
  };

  changeOpen = value => {
    const { dashboard, contentPages } = this.props;
    if (this.state.open_step == value) {
      this.setState({ open_step: -1 });
    } else {
      this.setState({ open_step: value });
      logEvent('ChangeActiveActionItem', {
        action_item: contentPages.filter(item => !dashboard.removed_steps.includes(item.type))[value - 1].type,
      });
    }
  };

  render() {
    const {
      annuities,
      pensions,
      trustFunds,
      unclassifiedIncomes,

      accounts,
      history,
      jobs,
      onContinue,
      openEmailDialog,
      openRegistrationDialog,
      people,
      results,
      savings,
      spendingPlan,
      wealthManagement,
      dashboard,
      contentPages,
    } = this.props;

    const { open_step } = this.state;

    if (
      !accounts ||
      !jobs ||
      !people ||
      !results ||
      !savings ||
      !wealthManagement ||
      (!annuities || !pensions || !trustFunds || !unclassifiedIncomes)
    ) {
      return <LoadingBar />;
    }

    const moneyLastsUntilAge = year => people[0].age + (year - new Date().getFullYear());

    const sortedItems = contentPages.filter(item => !dashboard.removed_steps.includes(item.type));

    const totalLength = Object.keys(sortedItems).length;

    const numberOfItemsToShow = this.calculateNumberOfItemsToShow(this.props.dashboard.intro_step);

    console.log('SORTED ITEMS', sortedItems);
    console.log('REMOVED ITEMS', dashboard.removed_steps);
    console.log('TOTAL LENGTH', totalLength);
    console.log('NUMBER OF ITEMS TO SHOW', numberOfItemsToShow);

    return (
      <div>
        <MTSkinny>
          <Typography tag="div" use="subtitle1" className="mb-2 mt-2">
            Based on your responses, here are some ideas for how a financial plan could help you achieve your goals.
          </Typography>
          {sortedItems.slice(0, numberOfItemsToShow).map((actionItem, index) => {
            return (
              <CarouselAction
                key={index + 1}
                open={open_step === index + 1}
                title={actionItem.title}
                subtitle={actionItem.subtitle}
                image={require(`../../images/${actionItem.image}`)}
                gain={actionItem.gain}
                explanation={actionItem.explanation}
                onToggle={() => this.changeOpen(index + 1)}
                onRemove={() => this.removeStep(actionItem.type)}
                onClick={
                  actionItem.onClickTransition
                    ? () => {
                        if (actionItem.onClickNewWindow) {
                          newWindow(actionItem.onClickTransition);
                        } else {
                          this.props.history.push(actionItem.onClickTransition);
                        }
                        this.props.trackEvent('CLICKED_LEARN_MORE', { url_slug: camelToKebabCase(actionItem.type) });
                      }
                    : null
                }
              />
            );
          })}

          {(DEBUG_STEP || dashboard.intro_step) < SHOW_TOP_THREE && (
            <div className="text-center mt-2">
              <Button
                style={{ height: '64px', flexDirection: 'column' }}
                theme="secondary-bg on-secondary"
                onClick={this.nextIntroStep}
              >
                <span style={{ display: 'block' }}>See next</span>
                <span style={{ display: 'block', height: '24px', marginTop: '4px' }}>
                  <Icon style={{ fontSize: '90px', lineHeight: '25px' }}>arrow_drop_down</Icon>
                </span>
              </Button>
            </div>
          )}
          {(DEBUG_STEP || dashboard.intro_step) === SHOW_TOP_THREE && (
            <div className="text-center mt-2">
              <Button
                style={{ height: '64px', flexDirection: 'column' }}
                theme="secondary-bg on-secondary"
                onClick={this.nextIntroStep}
              >
                <span style={{ display: 'block' }}>Finish Introduction</span>
                <span style={{ display: 'block', height: '24px', marginTop: '4px' }}>
                  <Icon style={{ fontSize: '90px', lineHeight: '25px' }}>arrow_drop_down</Icon>
                </span>
              </Button>
            </div>
          )}

          {(DEBUG_STEP || dashboard.intro_step) === TEASE_MORE_ITEMS && (
            <ToggleCard elevated={false}>
              <div onClick={this.nextIntroStep} style={{ display: 'flex', cursor: 'pointer' }}>
                <div className="p-2 pr-3">
                  <div
                    style={{
                      height: '50px',
                      width: '50px',
                      background: '#00d29c',
                      color: 'white',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Icon>add</Icon>
                  </div>
                </div>
                <div style={{ flexGrow: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography use="subtitle1" tag="div" className="pt-1">
                      <strong>{`See the ${totalLength - numberOfItemsToShow} other items we could help with`}</strong>
                    </Typography>
                    <div />
                  </div>
                  <Typography tag="div" use="body1">
                    <strong style={{ color: 'rgb(41, 149, 85)' }}>
                      +{currencyFormatter(
                        roundTo(sortedItems.slice(numberOfItemsToShow).reduce((acc, item) => acc + item.gain, 0), -3)
                      )}
                    </strong>
                    {' gain'}
                  </Typography>
                </div>
              </div>
            </ToggleCard>
          )}

          {(DEBUG_STEP || dashboard.intro_step) === FINISHED &&
            totalLength - numberOfItemsToShow > 0 && (
              <ToggleCard noRipple elevated={false}>
                <div
                  style={{ display: 'flex', cursor: 'pointer' }}
                  onClick={
                    this.props.user.email_cohort === COLLECT_CONTACT_ON_ACTION_ITEMS &&
                    /guest.*@harborplan.com/.test(this.props.user.email)
                      ? () => {
                          this.props.openRegistrationDialog(() => {}, () => {}, 'BEFORE_YOU_LEAVE');
                        }
                      : () => {}
                  }
                >
                  <div className="p-2 pr-3">
                    <div
                      style={{
                        height: '50px',
                        width: '50px',
                        background: '#e0e0e0',
                        color: 'white',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Icon>add</Icon>
                    </div>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Typography use="subtitle1" tag="div" className="pt-1">
                        <strong>{`Speak with us about ${totalLength -
                          numberOfItemsToShow} other ways we could help`}</strong>
                      </Typography>
                      <div />
                    </div>
                    <Typography tag="div" use="body1">
                      <strong style={{ color: 'rgb(41, 149, 85)' }}>
                        +{currencyFormatter(
                          roundTo(sortedItems.slice(numberOfItemsToShow).reduce((acc, item) => acc + item.gain, 0), -3)
                        )}
                      </strong>
                      {' gain'}
                    </Typography>
                  </div>
                </div>
              </ToggleCard>
            )}
        </MTSkinny>
        {(DEBUG_STEP || dashboard.intro_step) > SHOW_TOP_THREE && (
          <CustomCTA trackEvent={this.props.trackEvent}>
            <Typography
              tag="div"
              use="body1"
              className="pt-2"
              theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
            >
              This planning preview is a great place to get started. If you're interested in any of the ideas listed
              here, and want to know how our team can help, we'd love to talk.
            </Typography>
            <Typography
              tag="div"
              use="body1"
              className="pt-2 pb-2"
              theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
            >
              We'll review every unique aspect of your situation, and work with you to develop a strategy that meets all
              of your needs.
            </Typography>
          </CustomCTA>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    annuities: state.annuities.data,
    pensions: state.pensions.data,
    trustFunds: state.trustFunds.data,
    unclassifiedIncomes: state.unclassifiedIncomes.data,

    dashboard: state.modules.dashboard.data,
    accounts: state.modules.accounts.data,
    jobs: state.modules.jobs.data,
    people: state.people.data,
    results: state.simulations.results,
    savings: state.modules.savings.data,
    spendingPlan: state.modules.spendingPlan.data,
    state: state,
    user: state.user.user,
    wealthManagement: state.modules.wealthManagement.data,
    contentPages: state.contentPages.data,
  };
}

export default withEmailDialog(
  withRegistrationDialog(
    connect(mapStateToProps, {
      fetchAccountsModule,
      fetchIncomes,
      fetchJobsModule,
      fetchPeople,
      fetchSavingsModule,
      fetchSpendingPlan,
      fetchWealthManagement,
      runFullSimulation,
      nextIntroStep,
      trackEvent,
      updateDashboardData,
      nilSingleScore,
      updateFrame,
    })(PlanIntro)
  )
);
